import { type ComponentProps, type ReactNode } from 'react'
import { ArrowDown } from 'lucide-react'
import { twMerge } from 'tailwind-merge'
import { Button } from '@highlight/ui'

interface SidepanelSectionViewMoreProps extends Omit<ComponentProps<'button'>, 'type'> {
  icon?: ReactNode
}

export function SidepanelSectionViewMore({
  className,
  children = 'View more',
  icon = <ArrowDown aria-hidden="true" />,
  ...props
}: SidepanelSectionViewMoreProps) {
  return (
    <Button
      type="button"
      variant="ghost"
      size="sm"
      block
      left={icon}
      className={twMerge('justify-start', className)}
      {...props}
    >
      {children}
    </Button>
  )
}
